module.exports = {"attributes":{"viewBox":"0 0 13 15"},"content":"<path fill=\"#0F88EB\" fill-rule=\"evenodd\" d=\"M3.7 11.3v-6h-.5v-.6h2.3v2.7l2.9-2.7h2.3l-7 6.6zM13 2.2h-.6s-1.5 0-3-.6S7 .3 7 .3L6.5 0l-.4.3s-1 .7-2.5 1.3c-1.5.5-3 .6-3 .6H0v6.3C0 11.7 4.2 15 6.5 15S13 11.7 13 8.5V2.2z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-host.svg
// module id = 622
// module chunks = 0